import styled, { css } from 'styled-components';
import { spacing, breakpoints, borderRadius, themeLight } from '@naf/theme';
import { Text } from '@naf/text';
export const Container = styled.div.withConfig({
  displayName: "campaignBannerStyles__Container",
  componentId: "sc-8twk9q-0"
})(["display:flex;width:100%;position:relative;justify-content:space-between;padding:", ";border-radius:", ";box-sizing:border-box;", " ", " ", " ", " ", " ", " ", " ", ";@media (max-width:", "){padding:", ";}@media (max-width:", "){flex-direction:column;align-items:flex-start;padding:0;padding-top:", ";margin-top:", ";}"], spacing.space32, borderRadius.M, ({
  $color
}) => $color === 'yellow20' && css(["background-color:", ";"], ({
  theme
}) => theme.background ? theme.background.important : themeLight.background.important), ({
  $color
}) => $color === 'dew' && css(["background-color:", ";"], ({
  theme
}) => theme.background ? theme.background.brand : themeLight.background.brand), ({
  $variant
}) => $variant === 'small' && css(["flex-direction:column;align-items:center;padding:0;"]), ({
  $variant
}) => $variant === 'medium' && css(["padding:", ";"], spacing.space32), ({
  $variant
}) => $variant === 'large' && css(["padding:", ";"], spacing.space64), ({
  $img,
  $variant,
  $imageHeight
}) => $img && $variant === 'small' && css(["margin-right:0;width:unset;padding-top:", ";margin-top:", ";"], `${0.5 * $imageHeight}px`, `${0.5 * $imageHeight}px`), ({
  $img,
  $variant
}) => $img && $variant === 'medium' && css(["margin-right:", ";width:calc(100% - ", ");@media (max-width:", "){margin-right:0;width:unset;}"], spacing.space48, spacing.space48, breakpoints.s), ({
  $img,
  $variant
}) => $img && $variant === 'large' && css(["margin-right:96px;width:calc(100% - 96px);@media (max-width:", "){margin-right:0;width:unset;}"], breakpoints.s), breakpoints.m, spacing.space32, breakpoints.s, props => props.$img ? `${0.5 * props.$imageHeight}px` : 0, props => props.$img ? `${0.5 * props.$imageHeight}px` : 0);
export const Label = styled(Text).withConfig({
  displayName: "campaignBannerStyles__Label",
  componentId: "sc-8twk9q-1"
})(["margin:0;margin-bottom:", ";", " ", " ", ""], spacing.space8, ({
  $size
}) => $size === 'small' && css(["margin-bottom:", ";"], spacing.space8), ({
  $size
}) => $size === 'medium' && css(["margin-bottom:", ";"], spacing.space8), ({
  $size
}) => $size === 'large' && css(["margin-bottom:", ";@media (max-width:", "){margin-bottom:", ";}"], spacing.space16, breakpoints.s, spacing.space8));
export const Title = styled(Text).withConfig({
  displayName: "campaignBannerStyles__Title",
  componentId: "sc-8twk9q-2"
})(["margin:0;margin-bottom:", ";", " ", " ", ""], spacing.space16, ({
  $size
}) => $size === 'small' && css(["margin-bottom:", ";"], spacing.space16), ({
  $size
}) => $size === 'medium' && css(["margin-bottom:", ";"], spacing.space16), ({
  $size
}) => $size === 'large' && css(["margin-bottom:", ";@media (max-width:", "){margin-bottom:", ";}"], spacing.space24, breakpoints.s, spacing.space16));
export const Body = styled.div.withConfig({
  displayName: "campaignBannerStyles__Body",
  componentId: "sc-8twk9q-3"
})(["h1,h2,h3,h4,h5,p{margin:0;}@media (min-width:", "){h1,h2,h3{margin-bottom:", ";}}"], breakpoints.m, spacing.space8);
export const Buttons = styled.div.withConfig({
  displayName: "campaignBannerStyles__Buttons",
  componentId: "sc-8twk9q-4"
})(["display:flex;margin-top:", ";", " ", " ", ";@media (max-width:", "){flex-direction:column;width:100%;> button{width:100%;}> button:not(:first-of-type){margin-left:0;margin-top:", ";}}"], spacing.space24, ({
  size
}) => size === 'small' && css(["margin-top:", ";flex-direction:column;width:100%;> button{width:100%;}> button:not(:first-of-type){margin-left:0;margin-top:", ";}"], spacing.space24, spacing.space12), ({
  size
}) => size === 'medium' && css(["margin-top:", ";> button:not(:first-of-type){margin-left:", ";}"], spacing.space24, spacing.space12), ({
  size
}) => size === 'large' && css(["margin-top:", ";> button:not(:first-of-type){margin-left:", ";}@media (max-width:", "){margin-top:", ";}"], spacing.space32, spacing.space12, breakpoints.s, spacing.space24), breakpoints.s, spacing.space12);
export const Content = styled.div.withConfig({
  displayName: "campaignBannerStyles__Content",
  componentId: "sc-8twk9q-5"
})(["display:flex;flex-wrap:wrap;flex-direction:column;width:70%;word-break:break-word;box-sizing:border-box;padding-right:", ";", " ", " ", " &:only-child{width:100%;}@media (max-width:", "){width:unset;padding:", " ", " ", ";}"], spacing.space16, ({
  $size
}) => $size === 'small' && css(["width:unset;padding:", " ", " ", ";"], spacing.space24, spacing.space24, spacing.space32), ({
  $size
}) => $size === 'medium' && css(["width:70%;"]), ({
  $size
}) => $size === 'large' && css(["width:60%;"]), breakpoints.s, spacing.space24, spacing.space24, spacing.space32);
export const ImageWrapper = styled.div.withConfig({
  displayName: "campaignBannerStyles__ImageWrapper",
  componentId: "sc-8twk9q-6"
})(["min-height:calc(100% - 2 * ", ");max-height:calc(100% - 2 * ", ");max-width:30%;display:flex;", " ", " ", " ", " ", " ", ";@media (max-width:", "){min-height:calc(100% - 2 * ", ");max-height:calc(100% - 2 * ", ");max-width:30%;}@media (max-width:", "){order:-1;max-width:calc(100% - 2 * ", ");min-height:unset;max-height:100%;top:", ";", "}img{min-height:100%;min-width:100%;object-fit:cover;border-radius:", ";", ";@media (max-width:", "){object-fit:contain;max-height:100%;max-width:100%;}", "}"], spacing.space32, spacing.space32, ({
  $size
}) => $size === 'small' && css(["order:-1;max-width:calc(100% - 2 * ", ");min-height:unset;max-height:100%;padding-top:", ";"], spacing.space24, spacing.space24), ({
  $size
}) => $size === 'medium' && css(["min-height:calc(100% - 2 * ", ");max-height:calc(100% - 2 * ", ");max-width:30%;"], spacing.space32, spacing.space32), ({
  $size
}) => $size === 'large' && css(["min-height:calc(100% - 2 * ", ");max-height:calc(100% - 2 * ", ");max-width:40%;"], spacing.space64, spacing.space64), ({
  $illustration,
  $size,
  $imageHeight
}) => !$illustration && $size === 'small' && css(["position:absolute;top:", ";right:", ";padding-top:0;"], `${0.5 * -$imageHeight}px`, spacing.space24), ({
  $illustration,
  $size
}) => !$illustration && $size === 'medium' && css(["position:absolute;right:-", ";@media (max-width:", "){right:", ";}"], spacing.space48, breakpoints.s, spacing.space24), ({
  $illustration,
  $size
}) => !$illustration && $size === 'large' && css(["position:absolute;right:-96px;@media (max-width:", "){right:", ";}"], breakpoints.s, spacing.space24), breakpoints.m, spacing.space32, spacing.space32, breakpoints.s, spacing.space24, props => !props.$illustration ? `${0.5 * -props.$imageHeight}px` : 0, ({
  $illustration
}) => $illustration && css(["padding:", " ", " ", ";"], spacing.space24, spacing.space24, spacing.space32), borderRadius.S, ({
  $objectFit,
  $illustration
}) => ($illustration || $objectFit === 'contain') && css(["object-fit:contain;"]), breakpoints.s, ({
  $size
}) => $size === 'small' && css(["object-fit:contain;max-height:100%;max-width:100%;"]));
export const DiscountWrapper = styled.div.withConfig({
  displayName: "campaignBannerStyles__DiscountWrapper",
  componentId: "sc-8twk9q-7"
})(["margin-top:", ";"], spacing.space24);
//# sourceMappingURL=campaignBannerStyles.js.map